import { render, staticRenderFns } from "./SmSystemBar.vue?vue&type=template&id=09c0ad6b&scoped=true&"
import script from "./SmSystemBar.vue?vue&type=script&lang=ts&"
export * from "./SmSystemBar.vue?vue&type=script&lang=ts&"
import style0 from "./SmSystemBar.vue?vue&type=style&index=0&id=09c0ad6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c0ad6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VIcon,VSpacer,VSystemBar})
